import { Bounce, toast } from 'react-toastify'

export const handleSuccess = (text: string) => {
  toast(text, {
    position: 'top-right',
    autoClose: 25000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
    transition: Bounce,
    icon: (
      <svg width='32' height='32' viewBox='0 0 32 32' fill='none'>
        <circle cx='16' cy='16' r='16' fill={'#2AAB61'} />
        <path d='M9 16l4 4 10-10' stroke='#fff' strokeWidth='2' fill='none' />
      </svg>
    ),
    style: {
      borderLeft: '5px solid  #2AAB61',
      minWidth: '400px',
      fontSize: '14px',
    },
  })
}

export const handleError = (error: any) => {
  toast(error.response?.data?.error || 'Something went wrong', {
    position: 'top-right',
    autoClose: 25000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
    transition: Bounce,
    icon: (
      <svg width='32' height='32' viewBox='0 0 32 32' fill='none'>
        <circle cx='16' cy='16' r='16' fill={'#ff0c0c'} />
        <path d='M9 16l4 4 10-10' stroke='#fff' strokeWidth='2' fill='none' />
      </svg>
    ),
    style: {
      borderLeft: '5px solid #ff0c0c',
      minWidth: '400px',
      fontSize: '14px',
    },
  })
}
